/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Logo
 */
export interface Logo {
    /**
     * 
     * @type {string}
     * @memberof Logo
     */
    baseUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof Logo
     */
    name?: string;
}

/**
 * Check if a given object implements the Logo interface.
 */
export function instanceOfLogo(value: object): value is Logo {
    return true;
}

export function LogoFromJSON(json: any): Logo {
    return LogoFromJSONTyped(json, false);
}

export function LogoFromJSONTyped(json: any, ignoreDiscriminator: boolean): Logo {
    if (json == null) {
        return json;
    }
    return {
        
        'baseUrl': json['baseUrl'] == null ? undefined : json['baseUrl'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function LogoToJSON(value?: Logo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'baseUrl': value['baseUrl'],
        'name': value['name'],
    };
}

